import React, {useEffect, useState} from 'react';
import {useHistory} from "react-router-dom";
import { Nav, Button, Form, Navbar, Container, Toast} from "react-bootstrap";
import "../css/ReceiveData.css";
import logo from "../img/ksst_logo.png";
import { useOktaAuth } from "@okta/okta-react";

function ReceiveData() {
    const [plaintextSecret, setPlaintextSecret] = useState("");
    const history = useHistory();
    const [showA, setShowA] = useState(true);
    const [errorMsg, setErrorMsg] = useState({error: "", transID: ""});
    const [isError, setIsError] = useState(false);
    const [errorCode, setErrorCode] = useState(0);
    const [showError, setShowError] = useState(false);
    const [retrieved, setRetrieved] = useState(false);


    const toggleShowError = () => setShowError(!showError);



    useEffect(() => {
        var fullUrl = window.location.href
        fullUrl = fullUrl.split("retrieve")
        var realUrl = fullUrl[0] + "api/v1/retrieve"
        let params = fullUrl[1]?.split("/")
        let id = params[1]
        let auth = params[2]





        fetch(realUrl, {
            method: "POST",
            body: JSON.stringify({
                id: id,
                auth: auth
            }),
            headers: {
                "Content-Type": "application/json"
            }
        }).then((response) => function (response) {
                setErrorCode(response.status);
                return response.json();
            }(response))
            .then((responseJson) => function (responseJson) {
                if (responseJson.data != undefined){
                    setPlaintextSecret(responseJson.data);
                    setRetrieved(true);
                    window.history.replaceState(null, "nothing", window.location.origin + '/');
                }
                //TODO: Look for specific
                else {
                    setErrorMsg({error: responseJson.err, transID: responseJson.transaction_id});
                    setIsError(true);
                    setShowError(true);
                    setRetrieved(true);
                    window.history.replaceState(null, "nothing", window.location.origin + '/');
                }

            }(responseJson))
            .catch((error) => {
                console.log(error)
            });

    }, []);


    return (
        <>
            <Navbar bg="light" variant="light">

                <Navbar.Brand href="/">
                    <img src={logo} style={{width:100, height:100, marginTop: -7}} />
                </Navbar.Brand>
                <Nav className="ml-auto">
                    <Nav.Link href="/">Home</Nav.Link>
                    <Nav.Link href="/api/v1/swagger/index.html">API</Nav.Link>
                </Nav>
            </Navbar>
            <div className="custom_center">
                <h3> Kohl's Secret Sharing Tool</h3>


            </div>
            <br/>
            <div className="custom_center">
                <p>Allows for secure secret sharing via the use of a one-time link</p>
            </div>
            <hr className="hr_width"></hr>
            <div className="position: relative">
                <Toast variant="warning" show={showError} onClose={toggleShowError} className="move_right">
                    <Toast.Header closeButton={false}>
                        <strong className="mr-auto">Error Message        </strong>
                        <Button className="float-end" variant="light" onClick={() => setShowError(false)}>x</Button>

                    </Toast.Header>
                    <Toast.Body>
                        Error: {errorMsg.error}
                        <br></br>
                        Transaction ID: {errorMsg.transID}
                    </Toast.Body>

                </Toast>
            </div>

            {!isError && retrieved &&
            <Container fluid className="roomfac">
                <Form.Control type="text" placeholder= {plaintextSecret} className="textarea" rows="10" as="textarea" value={plaintextSecret} readOnly/>
                <div className="mt-3 text-center">
                    <Button variant="flat"  onClick={() => navigator.clipboard.writeText(plaintextSecret)}>
                        Copy
                    </Button>
                </div>
            </Container>
            }
            {isError && retrieved &&
                <div className="custom_center">
                    <b>Your secret has already been viewed or has expired. Reach out to the sender of your secret regarding this.</b>
                </div>
            }

        </>
    )
}

export default ReceiveData;

